export default __webpack_public_path__ + "static/media/logout.e513036e.svg";